var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-5"},[(_vm.activeClientChart)?_c('highcharts',{ref:"chart",attrs:{"options":_vm.columnChartOptions,"updateArgs":_vm.updateArgs}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }